import {
  cooperativeService,
  financeUrl,
  clientUrl,
  // parentUrl,
  userUrl,
} from '@/common/url-conf';
import {
  get,
  post
} from '@/common/axios';

export const mainApi = {
  // 查询伙伴类型
  querypartnertype: params => post(`${cooperativeService}/api/v1/partner/querypartnertype`,params),
  // 查询云市场协议需要签署协议 
  querycloudmarketprotocol: params => post(`${cooperativeService}/api/v1/protocol/querycloudmarketprotocol`,params),

  // 判断是否没有同意协议
  // isAgreeProtal: params => post(`${cooperativeService}/api/v1/common/queryuserinfo`,params),
  // 同意协议
  agreeProtal: (params, header) => post(`${cooperativeService}/api/v1/partner/updateagreement`, params, {
    notRepeatService: cooperativeService
  }),
  // 系统修改密码：=》发送验证码
  sendVialadMessage: (params, header) => post(`${cooperativeService}/api/v1/captcha/sendauthoritycaptcha`, params, Object.assign({
    notRepeatService: cooperativeService
  }, header)),
  // 获取用户email和手机简写
  queryEmailAndMobile: (params, header) => post(`${cooperativeService}/api/v1/account/queryemailandphone`, params, header),
  // 修改密码接口
  modifyPasswordBlock: (params, header) => post(`${cooperativeService}/api/v1/account/editpassword`, params, Object.assign({
    notRepeatService: cooperativeService
  }, header)),
  // 修改密码： => 重新查找邮箱手机号
  getModPwdFindConact: params => post(`${cooperativeService}/api/v1/account/queryaccount`, params),

  // 获取用户email和手机简写
  // queryEmailAndMobile: (params, header) => post(`${apiUrl}/v1/account/queryemailandphone`, params, header),
  // 获取用户基本信息
  // mainQueryUserInfo: p => post(clientUrl+'/customer/information/findCustomerByHeader'),
  mainQueryUserInfo: () => post(`${cooperativeService}/api/v1/common/queryuserinfo`),
  // 获取是否加入计划（刷新数据用）
  queryPartenrStatus: () => post(`${cooperativeService}/api/v1/common/queryPartenrStatus`),
  msgQueryTMsgAppManageEntityList: (p) => post('/broker-message-manage/msg/tmsgtaskmanage/getMsgTaskList', p),
  mainGetInfo: p => post(baseUrl + '/api/user/addFormId', p),
  mainGetDict: (service, code, data) => post(`${service || msgUrl}/dict/findByCode?dictCode=${code}`, data),
  // 获取重复提交token
  mainGetNotRepeatToken: (p, service) => get(`${service || msgUrl}/notRepeat/getNotRepeatToken`, p),
  //查询访客标识 0 是 1 否
  isVisitor: () => post(`${cooperativeService}/api/v1/account/visitorsstatus`),

  //修改密码
  //----张豆豆start----
  //更新密码
  updatePassWord: p => post(`${clientUrl}/customer/information/updatePassword`, p),
  //邮箱发送验证码
  clientSendCode: p => post(`${clientUrl}/customer/information/sendMailSecurityCode`, p),
  //手机短信发送验证码
  clientTelMsgCode: p => post(`${clientUrl}/customer/information/sendPhoneSecurityCode`, p),
  // 验证码校验
  clientVerifiyCode: p => post(`${clientUrl}/customer/information/customerAuthentication`, p),
  //----张豆豆end------

  //----潘越start----
  //获取顶部菜单
  userTopMenu: () => post(`${userUrl}/resource/getUserResource/0/test/root`),
  //获取菜单数据
  getLeftMenuData: (p) => post(`${userUrl}/authrolerechanneluser/resourcelistuserchannel?systemCode=partnerCenter`),
 //获取菜单导航数据
  getLeftMenuDataHear: (p) => post(`${userUrl}/authrolerechanneluser/resourcelistuserchannel?systemCode=${p}`),
  //----潘越end------
  // 总览如下 -------------------------------------------------------------------------
  // 客户数量查询
  getCustmerQuantity: (params, header) => post(`${cooperativeService}/api/v1/account/querycustomerInfo`, params, header),
  // 获取客户消费数据分析
  getCustmerCostDatabase: (params, header) => post(`${cooperativeService}/api/v1/account/querycustomerconsumptionanalysisdata?consumeType=${params.consumeType}`, params, header),
  // 获取未来七日客户资源到期数
  getFeatureSevenDayUnuseData: (params, header) => post(`${cooperativeService}/api/v1/account/querydueresourcesinnext7days`, params, header),
  // 公告数据查询
  getNoticeList: (params, header) => post(`${cooperativeService}/api/v1/account/querynotice`, params, header),
  // 查询伙伴基本信息
  getPartnerBaseInfo: (params, header) => post(`${cooperativeService}/api/v1/account/querypartner`, params, header),
  // 最近七日新增交易金额查询
  getSevenDayBusinessPrice: (params, header) => post(`${cooperativeService}/api/v1/account/querytransactionamountinlast7days?consumeType=${params.consumeType}`, params, header),
  // 工单数据查询
  queryOrderDatabase: (params, header) => post(`${cooperativeService}/api/v1/account/queryworkorder`, params, header),
  // 获取支付方式字典 
  getPayOptionDict: (p) => post(`${financeUrl}/Consumption/dict/findByCode?dictCode=PAY_METHODS`),
  //判断是否重签
  isResign: (p, header) => post(`${cooperativeService}/api/v1/protocol/protocolresign`, p, header),
  //协议内容
  protocolContent: (p) => post(`${cooperativeService}/api/v1/protocol/queryprotocolinfo`, p),
  listwhitelistsign:() =>post("/api/v1/whitelistconfig/listwhitelistsign"),
};

export const indexApi = {
  //----潘越start----
  //获取顶部菜单
  userTopMenu: () => post(`${cooperativeService}/resource/getUserResource/0/test/root`),
  //获取菜单数据
  // getLeftMenuData: (p) => post(`${cooperativeService}/resource/queryCustomerSideMenuList?subSystemCode=${p}`),
  //----潘越end------
  // 总览如下 -------------------------------------------------------------------------
  // 客户数量查询
  getCustmerQuantity: (params, header) => post(`${cooperativeService}/api/v1/account/querycustomerInfo`, params, header),
  // 获取客户消费数据分析
  getCustmerCostDatabase: (params, header) => post(`${cooperativeService}/api/v1/account/querycustomerconsumptionanalysisdata?consumeType=${params.consumeType}`, params, header),
  // 获取未来七日客户资源到期数
  getFeatureSevenDayUnuseData: (params, header) => post(`${cooperativeService}/api/v1/account/querydueresourcesinnext7days`, params, header),
  // 公告数据查询
  getNoticeList: (params, header) => post(`${cooperativeService}/api/v1/account/querynotice`, params, header),
  // 查询伙伴基本信息
  getPartnerBaseInfo: (params, header) => post(`${cooperativeService}/api/v1/account/querypartner`, params, header),
  // 最近七日新增交易金额查询
  getSevenDayBusinessPrice: (params, header) => post(`${cooperativeService}/api/v1/account/querytransactionamountinlast7days?consumeType=${params.consumeType}`, params, header),
  // 工单数据查询
  queryOrderDatabase: (params, header) => post(`${cooperativeService}/api/v1/account/queryworkorder`, params, header),
};



// WEBPACK FOOTER //
// ./src/modules/main/services.js